import { locationNamesRequest } from "./locationNamesRequest";

export default locationNamesRequest;
